import { useState } from 'react';
import { ChevronRight, X } from 'lucide-react';
import IdUploadStep from './IdUploadStep';
import FaceVerifyStep from './FaceVerifyStep';
import { useAuth } from '../../../../contexts/authContext';

const IdentityVerification = ({ quizId, quizTitle, initialStep = 'id_upload', onSuccess, onCancel }) => {
  const { profile } = useAuth();
  const [step, setStep] = useState(() => {
    if (profile?.student_id_card && initialStep === 'id_upload') {
      return 'webcam_verification';
    }
    return initialStep;
  });

  return (
    <div className="card bg-base-100 shadow-2xl border border-base-300 max-w-2xl mx-auto overflow-hidden animate-fade-in my-8">
      {/* Premium Gradient Top Border */}
      <div className="h-1.5 bg-gradient-to-r from-primary via-secondary to-accent" />
      
      <div className="card-body p-6 sm:p-8 space-y-6">
        
        {/* Header Block */}
        <div className="flex justify-between items-start gap-4">
          <div className="space-y-1">
            <span className="text-xs uppercase tracking-wider font-semibold text-primary">Identity Security Check</span>
            <h1 className="text-2xl font-bold tracking-tight">{quizTitle || 'Quiz Access Verification'}</h1>
            <p className="text-sm text-gray-500">Identity verification is required before taking this quiz.</p>
          </div>
          {onCancel && (
            <button 
              onClick={onCancel}
              className="btn btn-circle btn-ghost btn-sm"
              aria-label="Cancel"
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>

        {/* Progress Tracker */}
        <div className="flex items-center gap-2 text-sm bg-base-200 p-2.5 rounded-lg border border-base-300">
          <div className={`flex items-center gap-1.5 px-3 py-1 rounded-md font-semibold ${step === 'id_upload' ? 'bg-primary text-primary-content' : 'text-gray-500'}`}>
            <span className="w-5 h-5 bg-base-100 text-black flex items-center justify-center rounded-full text-xs">1</span>
            <span>Student ID</span>
          </div>
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <div className={`flex items-center gap-1.5 px-3 py-1 rounded-md font-semibold ${step === 'webcam_verification' ? 'bg-primary text-primary-content' : 'text-gray-500'}`}>
            <span className="w-5 h-5 bg-base-100 text-black flex items-center justify-center rounded-full text-xs">2</span>
            <span>Face Verify</span>
          </div>
        </div>

        {/* Step Rendering */}
        {step === 'id_upload' ? (
          <IdUploadStep 
            onNext={() => setStep('webcam_verification')}
            onCancel={onCancel}
          />
        ) : (
          <FaceVerifyStep 
            quizId={quizId}
            onSuccess={onSuccess}
            onCancel={onCancel}
          />
        )}

      </div>
    </div>
  );
};

export default IdentityVerification;
